import type { ListBuilderList } from '../../../types';

/**
 * Link Ended list (link drift, Chris 2026-09-05) — confirmed licences whose
 * regulator link to ANOTHER licence the client holds has ended: the state
 * board no longer lists the vet as managing licensee of the client's premise,
 * the PIC changed. The match is deliberately kept (a human decides whether the
 * licence still belongs to this client); this list is where that decision is
 * made. Cascade-created confirms are auto-unlinked instead and never appear
 * here. Backed by the locked `licenseLinkEnded: yes` filter, which reads the
 * confirmed match's `match_signals.link_ended_at` (written by the nightly
 * link-drift pipeline stage) — the same predicate as the dashboard's "Link
 * Ended" card, so the click-through count matches.
 */
export const linkEndedList: ListBuilderList = {
	id: 'default-licenses-link-ended',
	cacheTTL: 300000,
	name: 'Link Ended',
	type: 'default',
	active: true,
	sortOrder: 6,
	filterRules: {
		licenseLinkEnded: {
			defaultValue: [{ id: 'yes', label: 'Yes' }],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
